export default __webpack_public_path__ + "static/media/Bulgari - Logo.bfe10fd8.png";